import { useNavigate } from 'react-router-dom';
import styles from './CSCategoryIndex.module.css';
import datascience from '../../../images/datascience.png';
import fullstack from '../../../images/fullstack.png';
import aiagent from '../../../images/aiagent.png';
import computer_science from '../../../images/computer-science.png';
import monitor from '../../../images/monitor.png';

const SUBJECT_META = {
  monitor: { flag: monitor, color: '#6A1B9A', key: 'monitor' },
  computer_science: { flag: computer_science, color: '#6A1B9A', key: 'computer_science' },
  datascience: { flag: datascience, color: '#E91E63', key: 'datascience' },
  fullstack: { flag: fullstack, color: '#1565C0', key: 'fullstack' },
  aiagent: { flag: aiagent, color: '#6A1B9A', key: 'aiagent' },
};

const SUBJECT_DIRECTIONS = [

  {
    id: 'datascience',
    title: 'Data Science',
    icon: '',
    badge: 'Python & Analytics',
    description: 'Master Python data pipelines, NumPy array operations, Pandas DataFrames, visualization, and ML model evaluation.',
    tags: ['Python', 'Visualization', 'SQL', 'etc.'],
    color: '#FE4B01',
    borderColor: '#FE4B01',
    defaultCount: 6,
  },
  {
    id: 'fullstack',
    title: 'FullStack',
    icon: '',
    badge: 'Next.js & FastAPI',
    description: 'Build modern responsive applications with React Hooks, Flexbox/Grid CSS, Express REST APIs, and Async workflows.',
    tags: ['Next.js', 'Node.js', 'Express', 'REST API', 'etc.'],
    color: '#FE4B01',
    borderColor: '#FE4B01',
    defaultCount: 6,
  },
  {
    id: 'ai-agent',
    title: 'AI Agents',
    icon: '',
    badge: 'LLMs & RAG',
    description: 'Explore autonomous agent loops, prompt engineering, vector embeddings, RAG architecture, and structured function calling.',
    tags: ['Prompt Engineering', 'RAG', 'LLMs', 'etc.'],
    color: '#FE4B01',
    borderColor: '#FE4B01',
    defaultCount: 6,
  },
];

export default function CSCategoryIndex() {
  const subject = 'monitor';
  const navigate = useNavigate();
  const meta = SUBJECT_META[subject];



  return (
    <div className={styles.page}>
      {/* Header */}
      <header className={styles.header}>
        {meta?.flag && (
          <div className={styles.flag}>
            {typeof meta.flag === 'string' ? (
              <img src={meta.flag} alt={meta.key} width={32} height={32} style={{ objectFit: 'contain' }} />
            ) : (
              meta.flag
            )}
          </div>
        )}
        <div className={styles.headerTextWrap}>
          <h1 className={styles.title}>
            <span className={styles.titleIcon}></span> CS Learning Portal
          </h1>
        </div>
        <button className={styles.backBtn} onClick={() => navigate('/study')}>
          ← Back
        </button>
      </header>

      {/* Main Grid */}
      <main className={styles.container}>
        <div className={styles.grid}>
          {SUBJECT_DIRECTIONS.map(sub => {
            const cardMeta = SUBJECT_META[sub.id] || SUBJECT_META[sub.id.replace('-', '')];
            return (
              <div
                key={sub.id}
                className={styles.card}
                style={{
                  '--card-color': sub.color,
                  '--card-border': sub.borderColor,
                  background: sub.bgGradient,
                }}
                onClick={() => navigate(`/study/cs/${sub.id}`)}
              >
                <div className={styles.cardHeader}>
                  {cardMeta?.flag ? (
                    <img
                      src={cardMeta.flag}
                      alt={sub.title}
                      width={36}
                      height={36}
                      style={{ objectFit: 'contain' }}
                    />
                  ) : (
                    <span className={styles.cardIcon}>{sub.icon}</span>
                  )}
                </div>

                <h2 className={styles.cardTitle}>{sub.title}</h2>
                <p className={styles.cardDesc}>{sub.description}</p>

                <div className={styles.tagsRow}>
                  {sub.tags.map(t => (
                    <span key={t} className={styles.tag}>{t}</span>
                  ))}
                </div>

                <div className={styles.cardFooter}>
                  <span className={styles.enterBtn}>
                    Enter Canvas →
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </main>
    </div>
  );
}
